import { Link, useSearchParams } from "react-router-dom";
import { AuthLayout } from "../../components/AuthLayout";
import { RegisterForm } from "./RegisterForm";

export function Register() {
  const [params] = useSearchParams();
  const footer = <>¿Ya usas Markezy? <Link to="/login">Inicia sesión</Link></>;

  if (params.get("token")) {
    return (
      <AuthLayout kicker="Te han invitado" title="Completa tu registro" subtitle="Crea tu acceso para unirte a tu equipo en Markezy." footer={footer}>
        <RegisterForm />
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      kicker="Tu cuenta empieza aquí"
      title="Crea tu cuenta gratis"
      subtitle="Empieza con todas las funciones. Al terminar la prueba, conserva hasta 3 clientes gratis para siempre."
      footer={footer}
    >
      <RegisterForm />
    </AuthLayout>
  );
}
